export class AudioAvatarService {
  start(): void {}

  stop(): void {}

  speak(text: string): void {}
}
